import { render, staticRenderFns } from "./VersionFilter.vue?vue&type=template&id=daf98250&scoped=true"
import script from "./VersionFilter.vue?vue&type=script&lang=js"
export * from "./VersionFilter.vue?vue&type=script&lang=js"
import style0 from "./VersionFilter.vue?vue&type=style&index=0&id=daf98250&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf98250",
  null
  
)

export default component.exports